import { RootPage } from '../page';
import $api from '../../api';
import { ChangelogModel } from '../../models/Gen/BaseModels';
import languages from '../../utils/languages';
import ColorPicker from '../../components/colorPicker';

class ChangelogDetailView extends RootPage {
    constructor() {
        super();

        ColorPicker();

        let me = this;

        this.changelog = ko.observable();

        this.selectedLanguage = ko.observable(window.auth.project.SupportedLanguages[0]);
        this.supportedLanguages = languages.filter(i => window.auth.project.SupportedLanguages.indexOf(i.alpha2) !== -1);

        this.themes = [
            { id: 'default', text: 'Default' },
            { id: 'colored-parallax', text: 'Colored' },
            { id: 'image', text: 'With image' },
            { id: 'hidden', text: 'Hidden' },
            //{ id: 'night-sky', text: 'Night sky' },
            //{ id: 'blueprint', text: 'Blueprint' },
            //{ id: 'dark-dents', text: 'Dark dents' }
        ];

        this.selectedTheme = ko.computed({
            read: () => {
                if (!this.changelog()) return null;

                var curVal = ko.unwrap(this.changelog().themeConfig);

                if (!curVal) {
                    curVal = this.themes[0];
                    //console.log('FSDAFASD', curVal);
                    //this.selectedTheme(curVal.id);
                } else {
                    curVal = this.themes.filter(i => i.id === ko.unwrap(curVal.id));

                    if (curVal.length > 0) curVal = curVal[0];
                }

                return curVal.id;
            },
            write: (val) => {
                if (!this.changelog()) return;

                var themeConfig = this.changelog().themeConfig;

                if (!ko.isObservable(themeConfig)) {
                    this.changelog().themeConfig = ko.observable();
                }

                this.changelog().themeConfig(Object.assign(this.changelog().themeConfig() || {}, { id: val }));

                this.updatePreview();
            }
        });

        this.coloredOptionsShown = ko.observable(false);
        this.imageOptionsShown = ko.observable(false);

        this.selectedTheme.subscribe(newVal => {
            this.coloredOptionsShown(newVal === 'colored-parallax');
            this.imageOptionsShown(newVal === 'image');
        });

        this.themeBodyBgColor = createTitleAppearanceComputed('bodyBgColor');
        this.themeBodyColor = createTitleAppearanceComputed('bodyColor');
        this.themeHeaderBgColor = createTitleAppearanceComputed('headerBgColor');
        this.themeHeaderColor = createTitleAppearanceComputed('headerColor');
        this.themeFooterBgColor = createTitleAppearanceComputed('footerBgColor');
        this.themeFooterColor = createTitleAppearanceComputed('footerColor');

        this.backgroundImage = createTitleAppearanceComputed('bgImage');
        this.imgSizing = createTitleAppearanceComputed('imgSizing', 'auto');
        this.imgPosition = createTitleAppearanceComputed('imgPosition', 'top');
        this.imgSpacing = createTitleAppearanceComputed('imgSpacing', '33%');

        const that = this;
        function createTitleAppearanceComputed(titleThemeOpt, defaultValue) {
            const f = ko.observable(0);
            return ko.computed({
                read: () => {
                    const v = f();
                    let opts = getTitleThemeOpts();

                    return opts[titleThemeOpt] || defaultValue;
                },
                write: (val) => {
                    setTitleThemeOpts(o => {
                        o[titleThemeOpt] = val;
                    });
                    f(-1);
                    f(0);

                    that.updatePreview();
                }
            });
        }

        function getTitleThemeOpts() {
            try {
                let opts = JSON.parse(ko.unwrap(me.changelog().themeConfig().options));

                return opts || {};
            } catch (e) {
                return {};
            }
        }

        function setTitleThemeOpts(callback) {
            let opts = getTitleThemeOpts();

            callback(opts);

            if (!me.changelog().themeConfig().options) {
                me.changelog().themeConfig().options = ko.observable();
            }

            me.changelog().themeConfig().options(JSON.stringify(opts));
        }

        this.skipPropagatingChangeEvent = ko.observable(false);

        document.addEventListener('changelog_editor_onchange', () => {
            this.updatePreview();
        });
    }

    onInit() {
        this.changelog(new ChangelogModel(this.getServerSideData('changelog')));

        this.changelog().themeConfig.notifySubscribers();
    }

    getPreviewConfig() {
        const changelog = this.changelog().toJS();
        const cnt = changelog.contentsObject.filter(i => i.lng == this.selectedLanguage())[0];
        const title = changelog.titlesObject ? changelog.titlesObject.filter(i => i.lng == this.selectedLanguage())[0] : null;

        changelog.content = {
            [this.selectedLanguage()]: cnt ? cnt.content : {}
        }
        changelog.title = {
            [this.selectedLanguage()]: title ? title.content : ''
        }

        return JSON.parse(JSON.stringify(changelog));
    }

    initPreview() {
        setTimeout(() => {
            /** @type {HTMLIFrameElement} */
            const el = document.getElementById('previewer');

            el.contentWindow.postMessage({
                action: 'init',
                type: 'changelog',
                config: this.getPreviewConfig(),
                language: this.selectedLanguage()
            });
            this.isPreviewInit = true;
        }, 1500);
    }

    updatePreview() {
        if (!this.isPreviewInit) {
            this.initPreview();
            return;
        };

        const cfg = this.getPreviewConfig();

        /** @type {HTMLIFrameElement} */
        const el = document.getElementById('previewer');

        el.contentWindow.postMessage({
            action: 'update',
            type: 'changelog',
            config: cfg,
            language: this.selectedLanguage()
        });
    }

    onBgImageChanged(data, e) {
        const files = e.target.files;

        const file = files[0];

        const filesize = ((files[0].size / 1024) / 1024).toFixed(4);

        if (filesize > 0.8) {
            alert('Image size limit is 800 kB. We recommend compressing your image to provide better experience to your users.');
            return;
        }

        var formData = new FormData();
        formData.append('file', file);
        fetch('/files/' + auth.project.UniqueCode, { method: 'POST', body: formData, credentials: 'include' }).then(resp => {
            resp.json().then(r => {
                this.backgroundImage(r.fileId);
            });
        }, err => {
            alert('Image upload error :(');
        });
    }

    getChangelogFromServer(successCallback) {
        $api.changelogs.get(
            { projectCode: auth.project.UniqueCode, id: this.changelog().id() },
            {},
            (resp) => {
                //console.log('111');
                this.changelog(new ChangelogModel(resp));
                //console.log('222');
                if (successCallback) successCallback(resp);
            }
        );
    }

    publish() {
        if (confirm('Do you really want to publish the changelog? It will be visible to all users.')) {
            this.startSubmitting('publish');
            this.skipPropagatingChangeEvent(true);

            $api.changelogs.save(
                { projectCode: auth.project.UniqueCode, id: this.changelog().id() },
                this.changelog().toJS(),
                (resp) => {
                    $api.changelogs.publish(
                        { projectCode: auth.project.UniqueCode, id: this.changelog().id() },
                        {},
                        (resp) => {
                            TRACK_EVENT('Changelogs', 'Published', this.selectedTheme());

                            this.getChangelogFromServer(() => {

                            });

                            this.stopSubmitting('publish');
                        }
                    );

                    this.showToast('Changelog saved and published.');
                }
            );
        }
    }

    unpublish() {
        if (confirm('Do you really want to unpublish the changelog? Once published again, all users will see it again.')) {
            this.startSubmitting('unpublish');
            this.skipPropagatingChangeEvent(true);
            $api.changelogs.unpublish(
                { projectCode: auth.project.UniqueCode, id: this.changelog().id() },
                {},
                (resp) => {
                    this.stopSubmitting('unpublish');
                    this.getChangelogFromServer(() => {

                    });
                }
            );
        }
    }

    save() {
        this.startSubmitting('save');
        this.skipPropagatingChangeEvent(true);
        $api.changelogs.save(
            { projectCode: auth.project.UniqueCode, id: this.changelog().id() },
            this.changelog().toJS(),
            (resp) => {
                this.stopSubmitting('save');
                this.getChangelogFromServer(() => {

                });
                this.showToast('Changelog saved.');
            }
        );
    }
}

export default ChangelogDetailView;